import * as Long from "long";
import { of } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopBuffInfoResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopBuffs = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionCoopInfo.Received &&
            action.coop !== undefined &&
            action.coop.id !== undefined &&
            action.coop.id.equals(selectPlayerInfo(state$.value).coopId || Long.NEG_ONE);
    }), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.CoopBuffInfo,
            props: {
                coopId: action.coop.id,
                playerId: selectPlayerInfo(state$.value).playerId,
            },
        });
    }), retry(), switchMap(function (res) { return of(actionCoopBuffInfoResponse(res)); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopBuffs.ts
// module id = 1798
// module chunks = 3